/**
 * The api hands out saved cards with a one-time `token` that changes on every
 * list fetch, plus a stable `id`. A selection, or a payment stored on an
 * automation / auto-reload / inventory item (`{ id }`), is matched to the
 * freshly fetched list by `id`; a bare `token` only before the api sends ids.
 */
export function isSavedMethodRef (paymentData) {
  if (!paymentData) { return false }

  return Object.hasOwn(paymentData, 'id')
    || (Object.hasOwn(paymentData, 'token') && Object.keys(paymentData).length === 1)
}

export default function findSavedMethod (list, ref) {
  if (!ref) { return undefined }

  return list?.find((item) => (ref.id ? item.id === ref.id : item.token === ref.token))
}
